import React from 'react';
import { Progress } from './Progress';

export type AngleStatus = 'pending' | 'active' | 'completed';

export interface AngleItem {
  id: string;
  label: string;
  icon?: React.ReactNode;
  status: AngleStatus;
  thumbnail?: string | null;
  onClick?: () => void;
}

export interface AngleStripProps {
  angles: AngleItem[];
  activeAngleId?: string;
  onAngleClick?: (angleId: string) => void;
  className?: string;
  showLabels?: boolean;
}

export const AngleStrip: React.FC<AngleStripProps> = ({
  angles,
  activeAngleId,
  onAngleClick,
  className = '',
  showLabels = true,
}) => {
  return (
    <div className={`angle-strip ${className}`} role="tablist" aria-label="Ângulos da vistoria">
      {angles.map((angle) => (
        <button
          key={angle.id}
          type="button"
          role="tab"
          aria-selected={activeAngleId === angle.id}
          aria-controls={`panel-${angle.id}`}
          id={`tab-${angle.id}`}
          onClick={() => onAngleClick?.(angle.id)}
          className="angle-thumb"
          disabled={angle.status === 'completed' && activeAngleId !== angle.id}
        >
          <div
            className={`angle-thumb-image ${angle.status}`}
            role="img"
            aria-label={`${angle.label} ${angle.status === 'completed' ? 'concluído' : angle.status === 'active' ? 'ativo' : 'pendente'}`}
          >
            {angle.thumbnail ? (
              <img
                src={angle.thumbnail}
                alt=""
                className="w-full h-full object-cover"
              />
            ) : angle.icon ? (
              <div className="w-full h-full flex items-center justify-center text-on-surface-variant">
                {angle.icon}
              </div>
            ) : null}
            {angle.status === 'completed' && (
              <span className="check-badge material-symbols-outlined">check</span>
            )}
          </div>
          {showLabels && (
            <span className="angle-thumb-label">{angle.label}</span>
          )}
        </button>
      ))}
    </div>
  );
};

export interface AngleProgressProps {
  completed: number;
  total: number;
  currentAngle?: AngleItem;
  className?: string;
}

export const AngleProgress: React.FC<AngleProgressProps> = ({
  completed,
  total,
  currentAngle,
  className = '',
}) => {
  const percentage = total > 0 ? (completed / total) * 100 : 0;

  return (
    <div className={className}>
      <div className="flex items-center justify-between mb-2">
        <span className="font-label-md">
          {completed} de {total} fotos
        </span>
        <span className="font-label-md tabular-nums text-primary">
          {Math.round(percentage)}%
        </span>
      </div>
      <Progress value={completed} max={total} size="md" />
      {currentAngle && (
        <p className="mt-2 font-body-sm text-on-surface-variant">
          Capturando: <span className="font-label-md">{currentAngle.label}</span>
        </p>
      )}
    </div>
  );
};